const welcomePopupConfig = {
  dismissKey: 'lange:maison-wheel-dismissed-at',
  teaserOptOutKey: 'lange:maison-wheel-teaser-opted-out',
  spinKey: 'lange:maison-wheel-spin',
  subscribedKey: 'lange:welcome-subscribed',
  cooldownDays: 14,
  delayMs: 15000,
  scrollThreshold: 0.3,
  rewards: [{
    id: 'ten',
    label: '10% off',
    probability: 0.999,
    code: 'MAISON10',
    detail: '10% off your first order',
    angle: 0
  }, {
    id: 'discovery',
    label: 'Discovery Set',
    probability: 0.00025,
    code: 'CARAT-GIFT',
    detail: 'a complimentary Carat Discovery Set',
    angle: 288
  }, {
    id: 'five',
    label: '5% off',
    probability: 0.00025,
    code: 'MAISON5',
    detail: '5% off your first order',
    angle: 216
  }, {
    id: 'fifteen',
    label: '15% off',
    probability: 0.00025,
    code: 'MAISON15',
    detail: '15% off your first order',
    angle: 144
  }, {
    id: 'voucher',
    label: '€10 voucher',
    probability: 0.00025,
    code: 'MAISON10EUR',
    detail: 'a €10 voucher for your first order',
    angle: 72
  }]
};
function canUseStorage() {
  try {
    window.localStorage.setItem('__lange_popup_check', '1');
    window.localStorage.removeItem('__lange_popup_check');
    return true;
  } catch {
    return false;
  }
}
function secureRandom() {
  if (window.crypto?.getRandomValues) {
    const values = new Uint32Array(1);
    window.crypto.getRandomValues(values);
    return values[0] / 4294967296;
  }
  return Math.random();
}
function selectReward() {
  const roll = secureRandom();
  let total = 0;
  for (const reward of welcomePopupConfig.rewards) {
    total += reward.probability;
    if (roll < total) return reward;
  }
  return welcomePopupConfig.rewards[0];
}
function buildWelcomePopup() {
  if (document.querySelector('[data-welcome-popup]')) return;
  document.body.insertAdjacentHTML('beforeend', window.langeResolve(`
    <section class="lw-popup" data-welcome-popup hidden aria-hidden="true">
      <button class="lw-popup__backdrop" type="button" data-welcome-close aria-label="Minimise welcome offer"></button>
      <div class="lw-popup__panel" role="dialog" aria-modal="true" aria-labelledby="lw-popup-title" aria-describedby="lw-popup-description">
        <button class="lw-popup__close" type="button" data-welcome-close aria-label="Minimise welcome offer"><span></span><span></span></button>
        <aside class="lw-popup__wheel-stage" aria-hidden="true">
          <p class="lw-popup__stage-kicker">LANGÉ prize draw</p>
          <div class="lw-wheel" data-welcome-wheel>
            <span class="lw-wheel__pointer"></span>
            <div class="lw-wheel__disc">
              <span class="lw-wheel__ring lw-wheel__ring--outer"></span>
              <span class="lw-wheel__ring lw-wheel__ring--inner"></span>
              <span class="lw-wheel__reward lw-wheel__reward--ten">10%<small>off</small></span>
              <span class="lw-wheel__reward lw-wheel__reward--discovery"><small>Free</small>€39 Set</span>
              <span class="lw-wheel__reward lw-wheel__reward--five">5%<small>off</small></span>
              <span class="lw-wheel__reward lw-wheel__reward--fifteen">15%<small>off</small></span>
              <span class="lw-wheel__reward lw-wheel__reward--voucher">€10<small>voucher</small></span>
              <span class="lw-wheel__medallion">Spin<small>to win</small></span>
            </div>
          </div>
          <p class="lw-popup__stage-note">Free Carat Discovery Set<br><span>€39 value</span></p>
        </aside>
        <div class="lw-popup__content" data-welcome-content>
          <img class="lw-popup__mark" src="/lange/source/logo.png" alt="LANGÉ PARIS">
          <p class="lw-popup__eyebrow" data-welcome-eyebrow>Your first-order prize draw</p>
          <div class="lw-popup__top-prize"><span>Top prize</span><strong>Free Carat Discovery Set <i>€39 value</i></strong></div>
          <h2 id="lw-popup-title" data-welcome-title>Win the €39 Carat<br><em>Discovery Set.</em></h2>
          <p id="lw-popup-description" class="lw-popup__copy" data-welcome-copy>Enter your email, spin once and get your reward code straight away. The wheel includes a free Discovery Set, a €10 voucher, and 5%, 10% or 15% off.</p>
          <form class="lw-popup__form" data-welcome-form novalidate>
            <label for="lw-popup-email">Email address</label>
            <div class="lw-popup__field"><input id="lw-popup-email" name="email" type="email" inputmode="email" autocomplete="email" placeholder="Your email address" required></div>
            <p class="lw-popup__error" data-welcome-error aria-live="polite"></p>
            <button type="submit">Spin the prize wheel <i>→</i></button>
          </form>
          <label class="lw-popup__consent"><input id="lw-popup-marketing" name="marketing-consent" type="checkbox"><span>Yes, send me occasional Langé notes and offers by email. I can unsubscribe at any time.</span></label>
          <p class="lw-popup__terms">One turn per email. <a href="/version-1-tracked/en/terms/#maison-wheel-prize-draw">Prize draw rules</a> · <a href="/version-1-tracked/en/privacy/">Privacy policy</a>.</p>
          <button class="lw-popup__decline" type="button" data-welcome-close>Not now</button>
        </div>
      </div>
    </section>
    <div class="lw-popup__teaser-wrap" data-welcome-teaser-wrap hidden>
      <button class="lw-popup__teaser" type="button" data-welcome-teaser aria-label="Open the Maison welcome wheel">
        <strong aria-hidden="true">L</strong>
        <span class="lw-popup__teaser-label" aria-hidden="true">Spin to win</span>
        <span class="lw-popup__teaser-hint" aria-hidden="true"><b>Spin the wheel</b><small>Win the €39 set</small></span>
      </button>
      <button class="lw-popup__teaser-dismiss" type="button" data-welcome-teaser-dismiss aria-label="Hide the welcome wheel"><span></span><span></span></button>
    </div>`));
}
function initialiseWelcomePopup() {
  // Disabled on the live storefront pending the replacement popup.
  return;
  buildWelcomePopup();
  const popup = document.querySelector('[data-welcome-popup]');
  const panel = popup?.querySelector('.lw-popup__panel');
  const form = popup?.querySelector('[data-welcome-form]');
  const email = popup?.querySelector('#lw-popup-email');
  const marketingConsent = popup?.querySelector('#lw-popup-marketing');
  const error = popup?.querySelector('[data-welcome-error]');
  const teaser = document.querySelector('[data-welcome-teaser]');
  const teaserWrap = document.querySelector('[data-welcome-teaser-wrap]');
  const teaserDismiss = document.querySelector('[data-welcome-teaser-dismiss]');
  const wheel = popup?.querySelector('[data-welcome-wheel]');
  const content = popup?.querySelector('[data-welcome-content]');
  const eyebrow = popup?.querySelector('[data-welcome-eyebrow]');
  const topPrize = popup?.querySelector('.lw-popup__top-prize');
  const title = popup?.querySelector('[data-welcome-title]');
  const copy = popup?.querySelector('[data-welcome-copy]');
  const terms = popup?.querySelector('.lw-popup__terms');
  if (!popup || !panel || !form || !email || !error || !wheel || !content || !eyebrow || !topPrize || !title || !copy || !terms) return;
  const storageAvailable = canUseStorage();
  const forcedPreview = new URLSearchParams(window.location.search).get('welcome') === '1';
  const dismissedAt = storageAvailable ? Number(window.localStorage.getItem(welcomePopupConfig.dismissKey)) : 0;
  const onCooldown = dismissedAt && Date.now() - dismissedAt < welcomePopupConfig.cooldownDays * 24 * 60 * 60 * 1000;
  const subscribed = storageAvailable && window.localStorage.getItem(welcomePopupConfig.subscribedKey) === 'true';
  let wheelOptedOut = storageAvailable && window.localStorage.getItem(welcomePopupConfig.teaserOptOutKey) === 'true';
  let hasSpun = storageAvailable && Boolean(window.localStorage.getItem(welcomePopupConfig.spinKey));
  let active = false;
  let priorFocus = null;
  let timerId = null;
  let teaserInviteTimer = null;
  let engaged = false;
  let automaticTriggerUsed = false;
  function track(event, detail = {}) {
    const payload = {
      source: 'maison-wheel',
      ...detail
    };
    window.dispatchEvent(new CustomEvent(`lange:welcome-popup-${event}`, {
      detail: payload
    }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({
      event: `lange_welcome_popup_${event}`,
      ...payload
    });
  }
  function focusableElements() {
    return [...panel.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]')];
  }
  function setTeaserVisible(visible) {
    if (!teaser || !teaserWrap || visible && wheelOptedOut) return;
    if (!visible) {
      if (teaserInviteTimer) window.clearTimeout(teaserInviteTimer);
      teaserInviteTimer = null;
      teaser.classList.remove('is-visible', 'is-inviting');
      teaserWrap.hidden = true;
      return;
    }
    teaserWrap.hidden = false;
    window.requestAnimationFrame(() => {
      teaser.classList.add('is-visible');
      teaserInviteTimer = window.setTimeout(() => {
        teaser.classList.add('is-inviting');
        teaserInviteTimer = window.setTimeout(() => {
          teaser.classList.remove('is-inviting');
          teaserInviteTimer = null;
        }, 3400);
      }, 360);
    });
  }
  function updateTeaserPriority() {
    teaser?.classList.toggle('is-muted', window.scrollY > 72);
  }
  function suppressWheel() {
    wheelOptedOut = true;
    if (timerId) window.clearTimeout(timerId);
    if (storageAvailable) window.localStorage.setItem(welcomePopupConfig.teaserOptOutKey, 'true');
    setTeaserVisible(false);
    track('teaser-dismiss');
  }
  function closePopup(reason = 'dismissed', showTeaser = false) {
    if (!active) return;
    active = false;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    window.setTimeout(() => {
      popup.hidden = true;
    }, 220);
    if (reason === 'dismissed' && storageAvailable) window.localStorage.setItem(welcomePopupConfig.dismissKey, String(Date.now()));
    if (showTeaser && !hasSpun && !subscribed && !wheelOptedOut) {
      window.setTimeout(() => {
        setTeaserVisible(true);
        teaser?.focus();
      }, 240);
    }
    track('close', {
      reason,
      engaged
    });
    if (!showTeaser) priorFocus?.focus?.();
  }
  function openPopup(trigger = 'time-delay') {
    const isManualReopen = trigger === 'teaser';
    if (active || hasSpun || subscribed || wheelOptedOut && !forcedPreview || !isManualReopen && !forcedPreview && onCooldown) return;
    active = true;
    priorFocus = document.activeElement;
    setTeaserVisible(false);
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(() => popup.classList.add('is-open'));
    window.setTimeout(() => email.focus(), 120);
    track('view', {
      trigger: forcedPreview && !isManualReopen ? 'preview' : trigger
    });
  }
  function triggerWelcomeWheel(trigger) {
    if (automaticTriggerUsed) return;
    automaticTriggerUsed = true;
    if (timerId) window.clearTimeout(timerId);
    timerId = null;
    openPopup(trigger);
  }
  function pageScrollProgress() {
    const root = document.documentElement;
    const scrollableHeight = Math.max(0, root.scrollHeight - window.innerHeight);
    if (!scrollableHeight) return 0;
    return Math.max(0, Math.min(1, window.scrollY / scrollableHeight));
  }
  function showReward(reward) {
    wheel.classList.remove('is-spinning');
    popup.classList.remove('is-revealing');
    eyebrow.textContent = 'Your Maison welcome';
    topPrize.innerHTML = window.langeResolve(`<span>Your prize</span><strong>${reward.label}</strong>`);
    title.innerHTML = window.langeResolve('Your welcome<br><em>is ready.</em>');
    copy.innerHTML = window.langeResolve(`You have received <strong>${reward.detail}</strong>. Your code is ready to use at checkout.`);
    form.innerHTML = window.langeResolve(`<div class="lw-popup__success" role="status"><span>Your code</span><strong>${reward.code}</strong><a href="/version-1-tracked/en/discovery-set/">Shop the €39 Discovery Set <i>→</i></a></div>`);
    terms.textContent = 'We have kept this reward for this browser. It cannot be spun again.';
    content.classList.add('is-result');
    track('reward', {
      reward: reward.id
    });
  }
  popup.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', () => {
    const isBackdrop = button.classList.contains('lw-popup__backdrop');
    closePopup(isBackdrop ? 'backdrop' : 'dismissed', true);
  }));
  teaser?.addEventListener('click', () => openPopup('teaser'));
  teaserDismiss?.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();
    suppressWheel();
  });
  let scrollFrame = null;
  window.addEventListener('scroll', () => {
    if (scrollFrame) return;
    scrollFrame = window.requestAnimationFrame(() => {
      updateTeaserPriority();
      if (!automaticTriggerUsed && pageScrollProgress() >= welcomePopupConfig.scrollThreshold) {
        triggerWelcomeWheel('scroll-30');
      }
      scrollFrame = null;
    });
  }, {
    passive: true
  });
  updateTeaserPriority();
  document.addEventListener('keydown', event => {
    if (!active) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closePopup('escape', true);
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = focusableElements();
    const first = focusable[0];
    const last = focusable.at(-1);
    if (!first || !last) return;
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
  email.addEventListener('focus', () => {
    if (engaged) return;
    engaged = true;
    track('engage');
  }, {
    once: true
  });
  form.addEventListener('submit', event => {
    event.preventDefault();
    const value = email.value.trim();
    if (!email.validity.valid || !value) {
      error.textContent = 'Please enter a valid email address.';
      email.setAttribute('aria-invalid', 'true');
      email.focus();
      return;
    }
    const reward = selectReward();
    const optedIntoMarketing = Boolean(marketingConsent?.checked);
    hasSpun = true;
    if (storageAvailable) {
      window.localStorage.setItem(welcomePopupConfig.spinKey, JSON.stringify({
        reward: reward.id,
        at: Date.now()
      }));
      if (optedIntoMarketing) window.localStorage.setItem(welcomePopupConfig.subscribedKey, 'true');else window.localStorage.removeItem(welcomePopupConfig.subscribedKey);
    }
    error.textContent = '';
    email.removeAttribute('aria-invalid');
    form.querySelector('button[type="submit"]')?.setAttribute('disabled', 'disabled');
    form.querySelector('button[type="submit"]')?.classList.add('is-turning');
    wheel.style.setProperty('--wheel-turn', String(2160 + reward.angle));
    wheel.classList.add('is-spinning');
    popup.classList.add('is-revealing');
    window.dispatchEvent(new CustomEvent('lange:wheel-entry', {
      detail: {
        email: value,
        source: 'maison-wheel',
        reward: reward.id
      }
    }));
    if (optedIntoMarketing) {
      window.dispatchEvent(new CustomEvent('lange:newsletter-signup', {
        detail: {
          email: value,
          source: 'maison-wheel',
          reward: reward.id
        }
      }));
    }
    track('submit', {
      reward: reward.id
    });
    window.setTimeout(() => showReward(reward), 2850);
  });
  if (forcedPreview) {
    window.setTimeout(openPopup, 260);
    return;
  }
  if (onCooldown || subscribed || hasSpun || wheelOptedOut) {
    if (onCooldown && !subscribed && !hasSpun && !wheelOptedOut) {
      window.setTimeout(() => setTeaserVisible(true), 420);
    }
    return;
  }
  timerId = window.setTimeout(() => triggerWelcomeWheel('time-15'), welcomePopupConfig.delayMs);
  if (pageScrollProgress() >= welcomePopupConfig.scrollThreshold) triggerWelcomeWheel('scroll-30');
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseWelcomePopup, {
  once: true
});else initialiseWelcomePopup();